/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _ from 'lodash';

import styles from '../../styles';

const Select = styled.select`
  background-color: white;
  color: #16325c;
  border: 1px solid #d8dde6;
  border-radius: 0.25rem;
  width: ${(p) => p.width ? p.width : '100%'};
  transition: border 0.1s linear, background-color 0.1s linear;
  height: calc(1.875rem + (1px * 2));

  &:active, &:focus{
    outline: 0;
    border-color: #1589ee;
    background-color: white;
    box-shadow: 0 0 3px #0070D2;
  }

  &[disabled] {
    background-color: #ecebea;
    border-color: #c9c7c5;
    cursor: not-allowed;
    user-select: none;
  }

  & option {
    padding: 0.5rem;
  }
`;

const SelectComponent = ({ options, value, onChange, disabled, width }) => (
  <Select value={value} onChange={onChange} disabled={disabled} width={width}>
    { options.map((option, i) => {
      return <option key={i} value={option.value} onChange={onChange} id={option.id || i}>{option.text}</option>;
    })}
  </Select>
);

export default SelectComponent;
